import './index.css';
import Home from './pages/home/Home';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import JoinWaitlist from './pages/joinwaitlist/JoinWaitlist';
import PageNotFound from './pages/pagenotfound/PageNotFound';

function App() {
  return (
    <>
    <Router>
      <Routes>
        {/** Home/Landing*/}
      <Route path="/" element={<Home />}/>
      {/** Join Wait List */}
      <Route path="/join-wait-list" element={<JoinWaitlist />}/>
      {/** Page Not Found */}
      <Route path="*" element={<PageNotFound />}/>
      </Routes>
    </Router>
    </>
  );
}

export default App;
